import { render, staticRenderFns } from "./addGuide.vue?vue&type=template&id=769480bc&scoped=true&"
import script from "./addGuide.vue?vue&type=script&lang=js&"
export * from "./addGuide.vue?vue&type=script&lang=js&"
import style0 from "./addGuide.vue?vue&type=style&index=0&id=769480bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769480bc",
  null
  
)

export default component.exports